import type React from "react";
import { useEffect, useState } from "react";

import { AssetName } from "app/pages/digital-suite/home-page/components/CustomAssets/types";
import { AssetsService } from "app/services/AssetsService";

interface AssetIconProps {
    type: AssetName;
    size?: number;
}

export const AssetIcon: React.FC<AssetIconProps> = ({ type, size }) => {
    const [icon, setIcon] = useState<string>();
    const imageNames: Record<AssetName, string> = {
        [AssetName.Dashboard]: "dashboard",
        [AssetName.KeywordLists]: "keyword-lists",
    };

    useEffect(() => {
        const imageName = imageNames[type];
        const iconSrc = AssetsService.assetUrl(`/images/custom-assets/${imageName}.png`);
        setIcon(iconSrc);
    }, [type]);

    return (
        <img
            width={size || 32}
            height={size || 32}
            src={icon}
            alt={""}
        />
    );
};
